/* eslint-disable semi */
/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-25 15:55:53
 * @LastEditTime: 2019-08-23 19:01:51
 * @LastEditors: Please set LastEditors
 */
export default {
  data() {
    return {
      sliderArr: [],
      titleHtml: '',
      menuArr: []
    }
  },
  mounted() {
    this.pushData(this.$route.name);
    // this.$router.push(this.menuArr[0]);
  },
  methods: {
    pushData(name) {
      name = name.split('_')[0];
      let path = '/' + name + '/' + name + '_info';
      let data = {
        gsjs: {
          sliderArr: [
            require('@/assets/images/new_baner.jpg')
          ],
          titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">公司介绍</div><div style="padding: 10px">Company introduces</div></div>',
          menuArr: [
            {path, title: '公司介绍', englishTitle: 'Company introduces', name: name + '_info', params: {id: 0}}
          ]
        },
        gsxw: {
          sliderArr: [
            require('@/assets/images/new_baner.jpg')
          ],
          titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">公司新闻</div><div style="padding: 10px">Company News</div></div>',
          menuArr: [
            {path, title: '公司新闻', englishTitle: 'Company News', name: name + '_info', params: {id: 0}}
          ]
        },
        gsry: {
          sliderArr: [
            require('@/assets/images/new_baner.jpg')
          ],
          titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">公司荣誉</div><div style="padding: 10px">Company Honor</div></div>',
          menuArr: [
            {path, title: '公司荣誉', englishTitle: 'Company Honor', name: name + '_info', params: {id: 0}}
          ]
        },
        gcal: {
          sliderArr: [
            require('@/assets/images/new_baner.jpg')
          ],
          titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">工程案例</div><div style="padding: 10px">Engineering case</div></div>',
          menuArr: [
            {path, title: '工程案例', englishTitle: 'Engineering case', name: name + '_info', params: {id: 0}}
          ]
        },
        dj: {
          sliderArr: [
            require('@/assets/images/new_baner.jpg')
          ],
          titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">党建</div><div style="padding: 10px">DangJian</div></div>',
          menuArr: [
            {path, title: '党建', englishTitle: 'DangJian', name: name + '_info', params: {id: 0}}
          ]
        },
        rlzy: {
          sliderArr: [
            require('@/assets/images/new_baner.jpg')
          ],
          titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">人力资源</div><div style="padding: 10px">Human Resources</div></div>',
          menuArr: [
            {path, title: '在线招聘', englishTitle: 'Online recruitment', name: name + '_info', params: {id: 0}},
            {path, title: '留言板', englishTitle: 'Message Board', name: name + '_info', params: {id: 1}}
          ]
        },
        xxgk: {
          sliderArr: [
            require('@/assets/images/new_baner.jpg')
          ],
          titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">信息公开</div><div style="padding: 10px">Information</div></div>',
          menuArr: [
            {path, title: '信息公开', englishTitle: 'Information', name: name + '_info', params: {id: 0}}
          ]
        }
        // gdjt: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">轨道交通</div><div style="padding: 10px">Urban Rail Transit</div></div>',
        //   menuArr: [
        //     {path, title: '施工', englishTitle: 'Construction', name: name + '_info', params: {id: 0}},
        //     {path, title: '设计', englishTitle: 'Design', name: name + '_info', params: {id: 1}},
        //     {path, title: '建设管理', englishTitle: 'Construction Management', name: name + '_info', params: {id: 2}}
        //   ]
        // },
        // video: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">公司视频</div><div style="padding: 10px">Company Video</div></div>',
        //   menuArr: [
        //     {path, title: '公司视频', englishTitle: 'Video', name: name + '_info'}
        //   ]
        // },
        // about: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">生态修复</div><div style="padding: 10px">Ecological Rehabilitation</div></div>',
        //   menuArr: [
        //     {path, title: '生态修复', englishTitle: 'Ecological Rehabilitation', name: name + '_info', params: {id: 0}}
        //   ]
        // },
        // news: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">招采信息</div><div style="padding: 10px">Bidding information</div></div>',
        //   menuArr: [
        //     {path, title: '采购公告', englishTitle: 'Purchase announcement', name: name + '_info', params: {id: 0, aid: 1}},
        //     {path, title: '补充公告', englishTitle: 'Supplementary notice', name: name + '_info', params: {id: 1, aid: 1}},
        //     {path, title: '成交候选人公示', englishTitle: 'Announcement', name: name + '_info', params: {id: 2, aid: 1}},
        //     {path, title: '供应商门户', englishTitle: 'Supplier Portal', name: name + '_info', params: {id: 3, aid: 1}}
        //   ]
        // },
        // product: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">工程案例</div><div style="padding: 10px">Engineering case</div></div>',
        //   menuArr: [
        //     {
        //       path,
        //       title: '地下工程',
        //       englishTitle: 'Underground Construction',
        //       name: name + '_info',
        //       params: {id: 0, aid: 1}
        //     },
        //     {path, title: '道路桥梁', englishTitle: 'Road and Bridge', name: name + '_info', params: {id: 1, aid: 1}},
        //     {path, title: '水工', englishTitle: 'Water Environmental', name: name + '_info', params: {id: 2, aid: 1}},
        //     {
        //       path,
        //       title: '工业与民用建筑',
        //       englishTitle: 'Industrial and Civil Buildings',
        //       name: name + '_info',
        //       params: {id: 3, aid: 1}
        //     }
        //   ]
        // },
        // core: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">科技创新</div><div style="padding: 10px">Technological</div></div>',
        //   menuArr: [
        //     {path, title: '科技创新', englishTitle: 'Technological', name: name + '_info', params: {id: 0}}
        //   ]
        // },
        // human: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">信息公开</div><div style="padding: 10px">Information</div></div>',
        //   menuArr: [
        //     {path, title: '公司新闻', englishTitle: 'Company News', name: name + '_info', params: {id: 0, aid: 1}},
        //     {path, title: '公司荣誉', englishTitle: 'Company Honor', name: name + '_info', params: {id: 1, aid: 1}},
        //     {path, title: '公司介绍', englishTitle: 'Company introduces', name: name + '_info', params: {id: 2, aid: 1}},
        //     {path, title: '职工保护', englishTitle: 'Employee Protection', name: name + '_info', params: {id: 3, aid: 1}},
        //     {path, title: '在线招聘', englishTitle: 'Online recruitment', name: name + '_info', params: {id: 4, aid: 1}}
        //   ]
        // }
        // contact: {
        //   sliderArr: [
        //     require('@/assets/images/new_baner2.jpg')
        //   ],
        //   titleHtml: '<div style="color: #fff;background-color:#00388b;font-weight: bold"><div style="padding: 10px">企业党建</div><div style="padding: 10px">QiYe DangJian</div></div>',
        //   menuArr: [
        //     {path, title: '党旗飘扬', englishTitle: 'Dang qi piao yang', name: name + '_info', params: {id: 0, aid: 1}},
        //     {path, title: '群团建设', englishTitle: 'Qun tuan jian she', name: name + '_info', params: {id: 1, aid: 1}},
        //     {path, title: '创先争优', englishTitle: 'Chuang xian zheng you', name: name + '_info', params: {id: 2, aid: 1}},
        //     {path, title: '档案情怀', englishTitle: 'Dang an qing huai', name: name + '_info', params: {id: 3, aid: 1}},
        //     {path, title: '相关链接', englishTitle: 'Xiang guan lian jie', name: name + '_info', params: {id: 4, aid: 1}}
        //   ]
        // }
      };
      name = name.split('_')[0];
      this.sliderArr = [];
      for (let i = 0; i < data[name]['sliderArr'].length; i++) {
        let tempData = data[name]['sliderArr'][i];
        this.$set(this.sliderArr, i, tempData)
      }
      this.menuArr = {};
      for (let i = 0; i < data[name]['menuArr'].length; i++) {
        let tempData = data[name]['menuArr'][i];
        this.$set(this.menuArr, i, tempData)
      }
      this.titleHtml = data[name]['titleHtml']
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/mixin.js